import api from "./api";

export const callGetStatisticsByLottoId = async (lottoId) => {
    try {
        return await api.get(`/statistics/dashboard/info/lotto/${lottoId}`);
    } catch (error) {
        console.log("Error callGetStatisticsByLottoId");
    }
};
